import api from '@/services/api'

export default {
  login(user, password) {
    return api.post('/users/auth', { user, password })
  },

  getData() {
    return api.get('/users')
  },

  getStats() {
    return api.get('/users/stats')
  },
}